import React, { Component, useState, useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate, Outlet } from "react-router-dom";

// this is used to create scrollbars on windows devices like the ones from apple devices
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// react component that creates notifications (like some alerts with messages)
import NotificationSystem from "react-notification-system";

import DefaultSidebar from "../components/Sidebar/DefaultSidebar";
import DefaultNavbar from "../components/Navbars/DefaultNavbar";
import DefaultFooter from "../components/Footer/DefaultFooter";

import image from "../assets/img/full-screen-image-3.jpg";

// style for notifications
import { style } from "../variables/Variables";
import { useAuth } from "../contexts/authContext";
import { Result } from "../types/Result";
import { useNotifications, Notification } from "../contexts/notificationContext";

let ps: PerfectScrollbar;

const DefaultLayout: React.FC = () => {
    const [redirectTo ] = useState<string>('');
    const [img] = useState<string>(image);
    const [color] = useState<string>("black");
    const [hasImage] = useState(true);
    const [minimizedSidebar, setMini] = useState<boolean>(false);
    const [navbar] = useState<boolean>(false);

    const mainPanelRef = useRef<HTMLDivElement>(null);
    const notificationSystemRef = React.createRef<NotificationSystem>();

    const { user, isAuthenticated, logout, changeLanguage } = useAuth();
    const { notifications, removeNotifications } = useNotifications();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (navigator.platform.indexOf("Win") > -1) {
            if (mainPanelRef.current)
                ps = new PerfectScrollbar(mainPanelRef.current);
        }

        if (document.documentElement.className.indexOf("nav-open") !== -1) {
            document.documentElement.classList.toggle("nav-open");
        }

        if (navigator.platform.indexOf("Win") > -1) {
            if (ps !== undefined) {
                ps.destroy();
            }
        }

        if (navigator.platform.indexOf("Win") > -1) {
            setTimeout(() => { ps.update(); }, 350);
        }

    }, []);

    useEffect(() => {
        if (notificationSystemRef.current && notifications.length > 0) {
            notifications.forEach(function (notification, index) {
                notificationSystemRef.current.addNotification(notification);
            });
            removeNotifications(notifications);
        }
    }, [notificationSystemRef.current, notifications]);

    function handleMiniClick() {
        setMini(!minimizedSidebar);
        document.body.classList.toggle("sidebar-mini");
    }

    if (!isAuthenticated())
        return <Navigate to={`/auth/login`} replace state={{ from: location }} />;

    if (user && user.changePasswordOnNextLogin === true)
        return <Navigate to={`/auth/changeDefaultPassword`} replace state={{ from: location }} />;

    if (redirectTo !== '' && redirectTo !== location.pathname) {
        navigate(redirectTo);
    }

    return (
        <div className="wrapper">
            <NotificationSystem ref={notificationSystemRef} style={style} />
            <DefaultSidebar backgroundImageUrl={img} color={color} hasImage={hasImage} minimized={minimizedSidebar} />
            <div className={"main-panel" + (location.pathname === "/maps/full-screen-maps" ? " main-panel-maps" : "")} ref={mainPanelRef} >
                <DefaultNavbar handleMiniClick={handleMiniClick} navbar={navbar} />
                <Outlet />
                <DefaultFooter fluid />
            </div>
        </div>
    );
}
export default DefaultLayout;